"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Query = void 0;
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Query = ({
  searchPhrase,
  text,
  showIcon = true,
  onClick,
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const label = (0, _react.useMemo)(() => {
    const textWithBoldPhrase = (0, _presentationUtils.boldMatchedText)({
      searchPhrase,
      text
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Label, {
      color: "textPrimary",
      children: textWithBoldPhrase
    });
  }, [searchPhrase, text]);
  const icon = (0, _react.useMemo)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SearchIcon, {}), []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledChip, {
    variant: "rounded",
    "data-testid": getTestId(_constants.QUERY),
    label: label,
    icon: showIcon ? icon : undefined,
    className: className,
    onClick: onClick
  });
};
exports.Query = Query;
